import { colors } from "@material-ui/core";
const white = "#FFFFFF";
const black = "#000000";
const bG = "#F8F9FA";

export default {
  black,
  white,
  bG,
  // OneVision PLATFORM brand primary = MAGENTA (chrome only) — locked 2026-06-27
  // (was navy #1B3A6B; magenta #b21d6e ≈ oklch(0.498 0.199 353.2), the house brand)
  primary: {
    contrastText: white,
    dark: "#8a1657",
    main: "#b21d6e",
    light: "#cf4a92",
  },
  secondary: {
    contrastText: white,
    dark: "#C27D0E",
    main: "#F5A623",
    light: "#F7B84E",
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: "#B71C1C",
    main: "#E53935",
    light: "#EF9A9A",
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
  },
  background: {
    default: "#F8F9FA",
    paper: white,
  },
  //icon: "#1c1c1c",
  icon: colors.blueGrey[900],
  divider: "#E0E0E0",
};
